/**
 * Constructs a string using a simplified ISO 8601 format (with milliseconds) with local offset i.e. `YYYY-MM-DD HH:mm:ss.sss`
 *
 * `.toISOString()` timezone is always UTC, so the offset needs to be accounted for before construction
 *
 * @param {object} optParams Optional parameters
 * @param {Date} [optParams.dateTime=new Date()] (Optional) The `Date` object to convert. Default is the current date and time
 * @param {string} [optParams.separator=' '] (Optional) The character separating the date and time portion of the string. Default is ' ' (space)
 * @returns {string} A formatted string representing the given date and time (with local offset)
 */
export default function createISODateTime({
  dateTime = new Date(),
  separator = ' ',
} = {}) {
  const timeOffset = dateTime.getTimezoneOffset() * 60 * 1000; // ms
  // Previously read Date.now() here, so the dateTime arg was effectively
  // ignored (caught 2026-05-18 by common/__tests__/createISODateTime.test.js).
  const offsetTime = new Date(dateTime.getTime() - timeOffset);
  const timeString = offsetTime.toISOString().slice(0, -1); // remove 'Z' suffix
  const timeStrong = timeString.replace('T', separator); // replace 'T' indicator

  return timeStrong;
}
